import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Subheader, ListItem } from 'material-ui';
import { groupBy, toPairs } from 'lodash';
import { Loading } from '../../common/components/loading.component';
import { Image } from '../../common/components/image.component';
import { FontAwesome } from '../../common/components/font-awesome';
import { FeedPostApprovalDialog } from './feed-post-approval-dialog.container';

const styles = {
  photosList: {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    justifyContent: 'flex-start',
    paddingLeft: '16px',
  },
  photoItem: { width: '50px', paddingRight: '10px', cursor: 'pointer' },
};

export class FeedPostApprovalsView extends Component {
  static propTypes = {
    approvals: PropTypes.shape({
      loading: PropTypes.bool.isRequired,
      error: PropTypes.any,
      waitingFeedPostApprovals: PropTypes.arrayOf(PropTypes.object),
    }).isRequired,
    height: PropTypes.number,
  };

  constructor() {
    super();
    this.state = { currentApproval: null };
  }

  openApproval(approval) {
    this.setState({ currentApproval: approval });
  }

  close() {
    this.setState({ currentApproval: null });
  }

  render() {
    if (this.props.approvals.loading && !this.props.approvals.waitingFeedPostApprovals) {
      return <Loading />;
    }

    let { waitingFeedPostApprovals } = this.props.approvals;
    waitingFeedPostApprovals = (waitingFeedPostApprovals || []).filter((i) => i.user);

    const approvalsByUser = toPairs(
      groupBy(waitingFeedPostApprovals, ({ user }) => user.id)
    );

    return (
      <div style={{ height: this.props.height, overflow: 'scroll' }}>
        <FeedPostApprovalDialog
          onRequestClose={() => this.close()}
          open={this.state.currentApproval !== null}
          approval={this.state.currentApproval}
        />
        <div>
          <Subheader>Pending Approvals</Subheader>
          {waitingFeedPostApprovals.length === 0 ? (
            <ListItem
              disabled={true}
              primaryText="There are no pending feed post approvals!"
              leftIcon={<FontAwesome name="smile-o" />}
            />
          ) : null}
          {approvalsByUser.map(([userId, approvals]) => (
            <div key={userId}>
              <Subheader>{approvals[0].user.name}</Subheader>
              <div style={styles.photosList}>
                {approvals.map((approval) => (
                  <div
                    key={approval.id}
                    style={styles.photoItem}
                    title={approval.title || approval.createdAt}
                    onClick={() => this.openApproval(approval)}
                  >
                    <Image size={50} src={approval.imageUrl} />
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    );
  }
}
